import { IPrintBehavior } from "./IPrintBehavior";

export interface IPrintBehaviorSpecifiable {
  printBehavior: IPrintBehavior;
}

export function instanceOfIPrintBehaviorSpecifiable(instance: any): instance is IPrintBehaviorSpecifiable {
  return instance
      && (instance.printBehavior !== undefined);
}
